module.exports = __webpack_public_path__ + "static/media/draggedSprayer.591b9bdb.png";